import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import BlogNewsletterForm from '@/molecules/Forms/BlogNewsletterForm/BlogNewsletterForm'

type Props = {
  title: string
  description: string
  bgColor: string
  isAside?: boolean
}

function BlogNewsletter({
  title,
  description,
  bgColor,
  isAside = false
}: Props) {
  return (
    <section
      className={clsx(
        'text-white',
        isAside ? 'rounded-md max-w-2xl mx-auto' : 'rounded-none'
      )}
      style={{ background: bgColor }}
    >
      <div
        className={clsx('container', isAside ? 'py-9 md:py-8' : 'py-5 md:py-9')}
      >
        <div
          className={clsx(
            'font-heading justify-center items-center',
            isAside ? '' : 'grid grid-cols-1 lg:grid-cols-12 gap-14 md:gap-8'
          )}
        >
          <div
            className={clsx(
              'md:text-left | lg:col-span-6',
              isAside ? 'pb-10' : ''
            )}
          >
            <h2
              className={clsx(
                'tracking-tight | mb-4',
                isAside
                  ? 'text-3xl font-semibold'
                  : 'text-3xl font-semibold lg:text-4xl'
              )}
              dangerouslySetInnerHTML={{ __html: title }}
            />
            {!isAside && description ? (
              <div
                className="text-lg | pb-7 md:pb-9"
                dangerouslySetInnerHTML={{ __html: description }}
              ></div>
            ) : null}
            <BlogNewsletterForm isAside={isAside} />
          </div>
          <div className="lg:col-start-8 lg:col-end-13 mx-auto relative">
            <Image
              src="/assets/blog/newsletter.svg"
              alt=""
              width={476}
              height={435}
              className="mx-auto"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlogNewsletter
